<template>
  <th class="with-checkbox ui-checkable">
    <TsCheckbox
      v-model="$parent.allItemsChecked"
      :disabled="$parent.checkableItems.length === 0"
      @change="$parent.toggleCheckingAllItems()"
    ></TsCheckbox>
  </th>
</template>

<script>
export default {
  name: 'CheckableHead'
}
</script>
